<template>
<div class="pointsRules">
    <div class="myPoints-nav-bar">
        <div class="left-icon" @click="onClickLeft"><van-icon name="arrow-left" /></div>
        <div class="bar-text">市民云学堂积分规则</div>
    </div>
    <div class="points-rules">
        <p class="title">一、积分说明</p>
        <p class="content">用户可以通过注册、课程学习等方式来获取积分，积分可以兑换积分商城中的商品，积分商城正在建设中，敬请期待。</p>
        <p class="title">二、积分获取方式</p>
        <p class="content">1、首次注册成功获得10积分；
            <br>2、课程学习积分：
            <br>（1）完成观看课程中1个视频获得1积分；
            <br>（2）每天课程学习最多获得8积分。
        </p>
    </div>
</div>
</template>
<script>
export default {
    name: 'pointsRules',
    data() {
        return {
        }
    },
    mounted(){
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        }
    },
}
</script>
<style lang="stylus" scoped>
    .pointsRules{
        // min-height:calc(100vh - 84px);
        min-height:100vh;
        .myPoints-nav-bar{
            padding:19px 24px;
            position relative
            border-bottom 1px solid #EAEAEA;
            .left-icon{
                position absolute;
                height 36px;
                top:50%;
                transform translateY(-50%)
                /deep/.van-icon-arrow-left{
                    color #000000;
                    font-size:0.96rem
                }
            }
            .bar-text{
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 50px;
                text-align center;
            }
        }
        .points-rules{
            padding:32px;
            .title{
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 45px;
                margin-bottom 24px;
            }
            .content{
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 46px;
                margin-bottom 48px;
            }
        }
    } 
</style>
